// extracted by mini-css-extract-plugin
module.exports = {"group":"styles_group__1AR1d","fluid":"styles_fluid__599j8","color":"styles_color__3t2Jc","disabled":"styles_disabled__2AK6X"};